import React from 'react';
import { intlShape, injectIntl } from 'react-intl';
import randomstring from 'uuid/v4';
import Lightbox from 'lightbox-react';

import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';

import Snackbar from '../../../labels/Snackbar';
import PanelInfo from '../../../labels/PanelInfo';
import { AttachFileIcon, ColapseAll } from '../../../../images/icons/WrapSvg';

const flatObject = (object, id) => {
    return Object.keys(object).map((i) => {
        const value = object[i];
        value.codigo = id ? id + '.' + i : i;
        if (value.campos) {
            value.campos = flatObject(value.campos, value.codigo);
        }
        if (value.hijos) {
            value.campos = flatObject(value.hijos, value.codigo);
        }
        if (value.instancias) {
            value.campos = flatObject(value.instancias, value.codigo);
        }
        return value;
    });
};

function toolbar(handle) {
    return (
        <ColapseAll
            key={'filter-menu-coplase-all'}
            className="hand"
            color={'secondary'}
            onClick={handle}
        />
    );
}

/* Helper function */
function download_file(fileURL, fileName) {
    // for non-IE
    if (!window.ActiveXObject) {
        var save = document.createElement('a');
        save.href = fileURL;
        save.target = '_blank';
        var filename = fileURL.substring(fileURL.lastIndexOf('/') + 1);
        save.download = fileName || filename;
        if (
            navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) &&
            navigator.userAgent.search('Chrome') < 0
        ) {
            document.location = save.href;
        } else {
            var evt = new MouseEvent('click', {
                view: window,
                bubbles: true,
                cancelable: false,
            });
            save.dispatchEvent(evt);
            (window.URL || window.webkitURL).revokeObjectURL(save.href);
        }
    } else if (!!window.ActiveXObject && document.execCommand) {
        // for IE < 11
        var _window = window.open(fileURL, '_blank');
        _window.document.close();
        _window.document.execCommand('SaveAs', true, fileName || fileURL);
        _window.close();
    }
}

class ListValues extends React.Component {
    state = {
        error: undefined,
        report_appcc: undefined,
    };

    constructor(props) {
        super(props);
        const tools = [toolbar(this.handleCollapse)];
        this.props.setTools(tools);
    }

    componentWillUnmount() {
        this.props.setTools([]);
    }

    static getDerivedStateFromProps(props, state) {
        const { report_appcc } = props;
        if (report_appcc !== state.report_appcc) {
            state.report_appcc = report_appcc;
            state.data =
                report_appcc && report_appcc.values ? flatObject(report_appcc.values, '') : [];
            return state;
        }
        return null;
    }

    handleScroll = (e) => {
        this.props.setProminentToolBar(e.currentTarget.scrollTop === 0);
    };

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    setHide = (arr, codigo) => {
        return arr.map((item) => {
            if (item.campos) {
                item.campos = this.setHide(item.campos, codigo);
            }
            if (item.codigo === codigo) item.show = !item.show;
            else if (codigo === undefined) item.show = false;
            return item;
        });
    };

    handleHide = (item) => (event) => {
        if (item.campos) {
            this.setState({ data: this.setHide(this.state.data, item.codigo) });
        }
    };

    handleCollapse = () => {
        this.setState({ data: this.setHide(this.state.data, undefined) });
    };

    handleClickOpen = (file) => {
        this.setState({ open: true, selected: file });
    };

    handleClose = (action) => {
        this.setState({ open: false, selected: undefined });
    };

    handleDownload = (file) => (event) => {
        event.preventDefault(); // Let's stop this event.
        event.stopPropagation(); // Really this time.
        fetch(`${process.env.REACT_APP_API_FILE}/${file.base}`, {
            method: 'GET',
            headers: {
                Authorization: sessionStorage.token,
                Accept: 'application/json',
            },
        })
            .then((response) => {
                return response.json();
            })
            .then((info) => {
                if (info && info.success) {
                    download_file(
                        `${process.env.REACT_APP_API_FILE}/${file.link}`,
                        info.data.nombre,
                    );
                } else if (info && info.error) {
                    this.setState({ error: info.error });
                }
            })
            .catch((error) => {
                this.setState({ error: error });
            });
    };

    render() {
        const { error, data, report_appcc, open, selected } = this.state;
        const Field = (item) => {
            const i = item.item;
            const background = i.alerta
                ? 'bg_lipstickligth'
                : i.desactivado
                    ? 'bg_cool_grey'
                    : i.instancias
                        ? 'bg_bluish_25'
                        : 'bg_white';

            if (!i.campos || i.campos.length > 0) {
                return (
                    <React.Fragment>
                        <div
                            key={randomstring()}
                            className={
                                'flex_auto_row boxBorder borderRadiusLeft hand ' + background
                            }
                        >
                            {i.campos && i.campos.length > 0 && (
                                <div
                                    className={
                                        'display_flex heigth100 width64px center borderRadiusLeft hand bg_bluish '
                                    }
                                    onClick={this.handleHide(i)}
                                >
                                    {!i.show && (
                                        <ExpandMore
                                            className={
                                                'icon margin_top_9 margin_right_12 gradIcon c_white'
                                            }
                                        />
                                    )}
                                    {i.show && (
                                        <ExpandLess
                                            className={
                                                'icon margin_top_9 margin_right_12 gradIcon c_white'
                                            }
                                        />
                                    )}
                                </div>
                            )}
                            {i.id && (
                                <div
                                    className={
                                        'flex_auto_row barlow_regular_textwrap  c_lipstick text_align_left padding_borders_text hand gradIcon upper margin_left_6'
                                    }
                                    dangerouslySetInnerHTML={{ __html: i.id }}
                                />
                            )}
                            <div className={'flex_full_column'}>
                                {i.fecha &&
                                    <div
                                        className={
                                            'flex_full_row barlow_italic_medium c_slate elements_from_right padding_borders_flat hand gradIcon upper'
                                        }
                                        dangerouslySetInnerHTML={{ __html: i.fecha }}
                                    />
                                }
                                <div
                                    className={
                                        'flex_full_row barlow_regular_textwrap c_slate text_align_left padding_borders_text hand gradIcon upper'
                                    }
                                    dangerouslySetInnerHTML={{ __html: i.nombre }}
                                />
                                {i.valor && !i.imagen && !i.archivo && !i.firma && (
                                    <div
                                        className={
                                            'flex_full_row barlow_semibold_small c_grey_blue text_align_left padding_borders_flat text_wrap hand gradIcon upper'
                                        }
                                    >
                                        {i.valor}
                                    </div>
                                )}
                                {i.valor &&
                                    i.imagen &&
                                    i.valor.map((f, index) => {
                                        if (f.thumbnail) {
                                            return (
                                                <div
                                                    className="flex_full_row padding_borders_flat"
                                                    key={randomstring()}
                                                >
                                                    <img
                                                        className="preview hand"
                                                        src={`${process.env.REACT_APP_API_FILE}/${f.thumbnail}`}
                                                        alt={f.name}
                                                        height="64"
                                                        width="64"
                                                        id={`thumbnail-${index}`}
                                                        onClick={() => this.handleClickOpen(f)}
                                                    />
                                                    <span className="barlow_regular_textwrap c_slate text_align_left">
                                                        {f.comentario}
                                                    </span>
                                                </div>
                                            );
                                        } else {
                                            return <div />;
                                        }
                                    })}
                                {i.valor &&
                                    i.archivo &&
                                    i.valor.map((f, index) => {
                                        return (
                                            <div
                                                className="flex_full_row padding_borders_flat"
                                                key={randomstring()}
                                            >
                                                <button
                                                    className="btn bg_ice_blue"
                                                    onClick={this.handleDownload(f)}
                                                >
                                                    <AttachFileIcon
                                                        color="primary"
                                                        style={{ fontSize: 16 }}
                                                    />
                                                </button>
                                                <span className="barlow_regular_textwrap c_slate text_align_left">
                                                    {f.comentario}
                                                </span>
                                            </div>
                                        );
                                    })}
                                {i.valor && i.firma && (
                                    <div
                                        className="flex_full_row padding_borders_flat"
                                        key={randomstring()}
                                    >
                                        <img src={i.valor} alt={''} className={'preview_sign'} />
                                    </div>
                                )}
                                {i.observaciones && (
                                    <div
                                        className={
                                            'flex_full_row barlow_italic_medium c_light_purple text_align_left padding_borders_flat text_wrap hand gradIcon upper'
                                        }
                                        dangerouslySetInnerHTML={{ __html: i.observaciones }}
                                    />
                                )}
                            </div>
                            {i.id && (
                                <div
                                    className={
                                        'flex_auto_row barlow_italic c_cool_grey text_align_left padding_borders_text hand gradIcon upper margin_right_6'
                                    }
                                    dangerouslySetInnerHTML={{
                                        __html: i.creada.replace(report_appcc.from, ''),
                                    }}
                                />
                            )}
                        </div>
                        <div key={randomstring()} className="flex_auto_column margin_left_64">
                            {i.show &&
                                i.campos &&
                                i.campos.length > 0 &&
                                i.campos.map((f) => {
                                    return <Field key={randomstring()} item={f} />;
                                })}
                            {i.show &&
                                i.hijos &&
                                i.hijos.length > 0 &&
                                i.hijos.map((f) => {
                                    return <Field key={randomstring()} item={f} />;
                                })}

                            {i.show &&
                                i.instancias &&
                                i.instancias.length > 0 &&
                                i.instancias.map((f) => {
                                    return <Field key={randomstring()} item={f} />;
                                })}
                        </div>
                    </React.Fragment>
                );
            } else {
                return <div />;
            }
        };
        return (
            <div
                className={'flex_full_column height100 padding_borders showbar overflow_x_scroll overflow_y_scroll'}
                onScroll={this.handleScroll}
            >
                {data &&
                    data.length > 0 &&
                    data.map((i) => {
                        return <Field key={randomstring()} item={i} />;
                    })}
                {(data && data.length === 0) &&
                    <PanelInfo id={'no_data'} />
                }
                {open && (
                    <Lightbox
                        mainSrc={`${process.env.REACT_APP_API_FILE}/${selected.link}`}
                        onCloseRequest={this.handleClose}
                    />
                )}
                {error && (
                    <Snackbar
                        open={true}
                        variant="error"
                        text={error}
                        onClose={this.handleCloseError.bind(this)}
                    />
                )}
            </div>
        );
    }
}

ListValues.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(ListValues);



// WEBPACK FOOTER //
// ./src/components/complex/reports/appcc/List.js